/**
 * returns date in Month DD, YYYY format
 * @param {String} date
 */
export const getFormattedDate = date => {
  date = date ? new Date(date) : new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString('default', { month: 'long' });
  let day = date.getDate();
  if (day < 10) day = `0${day}`;

  return `${month} ${day}, ${year}`;
};
